import { makeActionCreator } from '../App_Code/Utils';
import { ActPro } from '../App_Data/ActionTypes';

export const proAjout = makeActionCreator(ActPro.PRO_AJOUT, 'data');
export const proHistoAjout = makeActionCreator(ActPro.PRO_HISTORIQUE_AJOUT, 'data');



// WEBPACK FOOTER //
// ./src/Actions/ProActions.js